export default __webpack_public_path__ + "static/pinni-13f385d6f999de16e7cf4d36c741756c.png";